<div class="title-container">
  <h1 class="mat-headline content-bar-header-title">
    {{ title }}
    <ng-container class="block" *ngTemplateOutlet="headerTemplate"></ng-container>
  </h1>
  <div style="display: flex;">
  <div class="mat-subheading-1 content-bar-header-subtitle" *ngIf="subtitle" [innerHTML]="subtitle"></div>
  <a *ngIf="link" routerLink="{{link.href}}">{{link.label}}</a>
    <button *ngIf="additionalInfoIconFlag" mat-icon-button matTooltipPosition="right" 
    matTooltip="Additional Partner Information" [matTooltipShowDelay]="100"
    [mdePopoverTriggerFor]="additionalInfoPopover" mdePopoverTriggerOn="click"
    [mdePopoverBackdropCloseOnClick]="false">
    <mat-icon>info</mat-icon>
  </button>
</div>
</div>

<div class="button-container">
  <ng-container *ngFor="let button of buttons">
    <div *ngIf="button.separator && (!button.visible$ || (button.visible$ | async))" class="divider"></div>
    <app-content-header-button *ngIf="button.name || button.icon" 
      [ngClass]="{'btn-like-disable':button.appearAsDisabled}" [visible]="!button.visible$ || (button.visible$ | async)"
      [name]="button.name" [type]="button.type" [color]="button.color" [disabled]="button.disabled$ | async"
      [icon]="button.icon" [id]="button.id" (buttonClick)="onButtonClick(button)" matTooltip="{{button.tooltip}}">
    </app-content-header-button>
  </ng-container>
</div>

<span class="additionalInfo-btn">
  <mde-popover #additionalInfoPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
    <app-additional-partner-info-popup class="additionalInfo-popup" (onHit)="catchChildEvent(0)"
      [additionalPartnerInfo]="additionalPartnerInfo">
    </app-additional-partner-info-popup>
  </mde-popover>
</span>